import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  GetSiteVisitDetailsAsync,
  ISiteVisitDetails,
} from "../../api/ISiteVisit";
import { RootState } from "../store";

export interface SiteVisitState {
  fetchStatus: string;
  siteVisit?: ISiteVisitDetails;
}

const initialState: SiteVisitState = {
  fetchStatus: "Loading...",
  siteVisit: undefined,
};

export const loadSiteVisitAsync = createAsyncThunk(
  "siteVisit/load",
  async (siteVisitId: string) => {
    const response = await GetSiteVisitDetailsAsync(siteVisitId);
    // The value we return becomes the `fulfilled` action payload
    return response;
  }
);

export const siteVisitSlice = createSlice({
  name: "siteVisit",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {},
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {
    builder
      .addCase(loadSiteVisitAsync.pending, (state) => {
        state.fetchStatus = "loading";
      })
      .addCase(loadSiteVisitAsync.fulfilled, (state, action) => {
        state.fetchStatus = "idle";
        state.siteVisit = action.payload;
      });
  },
});

export const selectSiteVisit = (state: RootState) => state.siteVisit;

export default siteVisitSlice.reducer;
